import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { BrowserModule } from "@angular/platform-browser";
import { I18nModule } from "@spartacus/core";
import { FaxEmailPopupComponent } from "./fax-email-popup/fax-email-popup.component";


@NgModule({
  declarations: [FaxEmailPopupComponent],
  exports:[FaxEmailPopupComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    BrowserModule,
    FormsModule,
    I18nModule
  ],
  providers: [
  ]
})
export class FaxEmailPopupModule { }
